import React from 'react';
import PropTypes from 'prop-types';

// Design-system status pill. Pick a tone (or pass an explicit bg/fg).
// success = approved/active, warning = pending/submitted, error = denied/failed,
// info = brand-blue, neutral = muted. See DESIGN_SYSTEM.md §6.
const TONES = {
  success: { bg: '#eef5ea', fg: '#53A551' },
  warning: { bg: '#fde6d2', fg: '#F19235' },
  error: { bg: '#fdebe6', fg: '#b94f3c' },
  info: { bg: '#e8eef7', fg: '#4062E5' },
  neutral: { bg: '#f1f2f5', fg: '#546077' },
};

function StatusPill({ tone, children }) {
  const c = TONES[tone] || TONES.neutral;
  return (
    <span
      className="inline-flex items-center px-2.5 py-0.5 rounded-full whitespace-nowrap"
      style={{
        backgroundColor: c.bg, color: c.fg, fontSize: '11px', fontWeight: 600,
      }}
    >
      {children}
    </span>
  );
}

StatusPill.propTypes = {
  tone: PropTypes.oneOf(['success', 'warning', 'error', 'info', 'neutral']),
  children: PropTypes.node.isRequired,
};

StatusPill.defaultProps = { tone: 'neutral' };

export default StatusPill;
